import { useContext } from 'react';
import SettingsContext from '../shared/SettingsContext';

const useSettings = () => useContext(SettingsContext);

export default useSettings;
